import { useState } from 'react';
import './BarraNavegacao.css';

const BarraNavegacao = ({ user, onLogout, onNavigate, onLoginClick, shopName, logoUrl }) => {
    const [isOpen, setIsOpen] = useState(false);
    const isMaster = user?.isMaster;

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo" onClick={() => onNavigate('home')}>
                {logoUrl ? (
                    <img src={logoUrl} alt={shopName} />
                ) : (
                    <span className="navbar-logo-text">{shopName || 'StartWebb'}</span>
                )}
            </div>

            <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
                <a href="#home" className="nav-link" onClick={() => { onNavigate('home'); toggleMenu(); }}>Home</a>
                <a href="#barbeiros" className="nav-link" onClick={() => { onNavigate('home'); toggleMenu(); }}>Barbeiros</a>
                <a href="#localizacao" className="nav-link" onClick={() => { onNavigate('home'); toggleMenu(); }}>Localização</a>
                <a href="#contato" className="nav-link" onClick={() => { onNavigate('home'); toggleMenu(); }}>Contato</a>

                {user && user.isAdmin && (
                    <button className="nav-link dashboard-link" onClick={() => { onNavigate('dashboard'); toggleMenu(); }}>
                        Painel
                    </button>
                )}

                {user && !user.isAdmin && (
                    <>
                        <button className="nav-link dashboard-link" onClick={() => { onNavigate('history'); toggleMenu(); }}>
                            Agendamentos
                        </button>
                        <button className="nav-link dashboard-link" onClick={() => { onNavigate('profile'); toggleMenu(); }}>
                            Perfil
                        </button>
                    </>
                )}

                {user && (
                    <div className="user-profile-container">
                        <div className="user-greeting">
                            <span className="hola-text">Olá,</span>
                            <span className="user-name">{user.name}</span>
                        </div>
                        {isMaster && (
                            <button className="nav-btn master" onClick={() => { onNavigate('master'); toggleMenu(); }}>⚙️ Master</button>
                        )}
                        <button className="nav-btn logout" onClick={onLogout}>Sair</button>
                    </div>
                )}

                {!user && (
                    <div className="login-profile-container mobile-only">
                        <button className="nav-btn login-boxed" onClick={() => { onLoginClick('login'); toggleMenu(); }}>
                            Entrar
                        </button>
                    </div>
                )}
            </div>

            <div className="navbar-actions">
                {!user && (
                    <button className="login-button desktop-only" onClick={() => onLoginClick('login')}>Entrar</button>
                )}
                <div className="hamburger" onClick={toggleMenu}>
                    <span className={isOpen ? 'bar open' : 'bar'}></span>
                    <span className={isOpen ? 'bar open' : 'bar'}></span>
                    <span className={isOpen ? 'bar open' : 'bar'}></span>
                </div>
            </div>
        </nav >
    );
};

export default BarraNavegacao;
